import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as DiscardIcon } from "assets/icons/discard.svg";
import { convertHexToRGBA, getTextWidth } from "utils/commonUtils";
import { useOrganiseList } from "context/OrganiseListContext";
import Avatar from "components/Avatar/Avatar";
import { Tooltip } from "react-tooltip";
import useProperties from "hooks/useProperties";
import { ReactComponent as RemoveIcon } from "assets/icons/delete.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

const OrganiseList = ({ setIsOpenListDialog }) => {
  const {
    organiseLists,
    selectedOrganiseList,
    handleSelectOrganiseList,
    isDoubtPropertiesActive,
    isDiscardedPropertiesActive,
    setIsDoubtPropertiesActive,
    setIsDiscardedPropertiesActive,
  } = useOrganiseList();
  const { fetchDoubtProperties, fetchDiscardedProperties } = useProperties();
  const [organiseTextWidths, setOrganiseTextWidths] = useState({});
  const organiseTextRefs = useRef([]);

  useEffect(() => {
    const newWidths = {};

    organiseTextRefs.current.forEach((ref, index) => {
      if (ref) {
        const text = ref.textContent.trim();
        const computedStyle = getComputedStyle(ref);
        const font = `${computedStyle.fontWeight} ${computedStyle.fontSize} ${computedStyle.fontFamily}`;
        newWidths[index] = getTextWidth(text, font);
      }
    });

    setOrganiseTextWidths(newWidths);
  }, [organiseLists]);

  const toggleDoubtPropertyList = () => {
    setIsDiscardedPropertiesActive(false);
    document.body.style.overflow = "hidden";
    setIsDoubtPropertiesActive(!isDoubtPropertiesActive);
  };

  const toggleDiscardedPropertyList = () => {
    setIsDoubtPropertiesActive(false);
    document.body.style.overflow = "hidden";
    setIsDiscardedPropertiesActive(!isDiscardedPropertiesActive);
  };

  // Slider settings
  const settings = {
    modules: [Pagination],
    slidesPerView: "auto",
    pagination: false,
    freeMode: true,
    spaceBetween: 17,
    breakpoints: {
      640: {
        spaceBetween: 12,
      },
    },
  };

  return (
    <div className="w-full h-[220px] max-w-[1550px] overflow-hidden mx-auto bg-white rounded-[10px] pt-[26px] pb-[44px] pl-4 md:pl-[32px]">
      <div className="flex sm:items-center sm:justify-between flex-col sm:flex-row space-y-[9px] sm:space-y-0 pr-4 md:pr-[23px]">
        <h1 className="pl-1 text-[#373C47] font-bold text-[16px] leading-[19px] md:text-[24px] md:leading-[29.05px] ">
          Le tue Liste
        </h1>
        <div className="flex items-center space-x-[5px]">
          <button
            onClick={toggleDoubtPropertyList}
            className={`${
              isDoubtPropertiesActive ? "bg-primary text-white" : ""
            } border flex-shrink-0 border-primary text-primary rounded-[8px] px-[9px] h-[31px] text-[12px] font-medium cursor-pointer transition-all duration-200 ease-in hover:bg-primary hover:text-white`}
          >
            Vai alla Lista Dubbi
          </button>
          <div
            onClick={toggleDiscardedPropertyList}
            className={`${
              isDiscardedPropertiesActive
                ? "bg-[#FF6D59] text-white"
                : "text-[#FF6D59]"
            } flex flex-shrink-0 border border-[#FF6D59] hover:bg-[#FF6D59] hover:text-white transition-all group items-center space-x-2 rounded-[8px] h-[31px] px-[10px] text-[12px] font-medium cursor-pointer hover:opacity-85 duration-200 ease-in`}
          >
            <RemoveIcon
              className={`group-hover:stroke-white transition-colors duration-200 ease-in ${
                isDiscardedPropertiesActive
                  ? "stroke-white"
                  : "stroke-[#FF6D59]"
              } `}
            />
            <p>Vedi le proprietà scartate</p>
          </div>
        </div>
      </div>
      <div className="flex w-full items-center space-x-2 sm:space-x-[9px] mt-[22px] overflow-hidden">
        <div
          onClick={() => setIsOpenListDialog(true)}
          className="flex rounded-[12px] overflow-hidden group"
        >
          <div className="flex-shrink-0 z-[1] w-[52px] bg-primary text-white rounded-[12px] h-[72px] md:h-[98px] cursor-pointer font-bold md:w-[64px] text-center text-[24px] flex items-center justify-center">
            +
          </div>
          <div className="border-2 w-0 group-hover:w-[310px] group-hover:-ml-[10px] cursor-pointer group-hover: flex items-center justify-center rounded-tr-[12px] rounded-br-[12px] transition-all duration-300 border-dashed border-primary overflow-hidden">
            <p className="whitespace-nowrap text-primary text-[15px] md:text-[20px] pl-[10px] font-medium bg-white">
              crea una nuova lista
            </p>
          </div>
        </div>

        {/* <div className="flex w-full items-center space-x-3 sm:space-x-[17px] pr-4 md:pr-[23px] overflow-x-auto scrollbar-hide"> */}
        <Swiper className="organise_list_swiper w-full" {...settings}>
          {organiseLists.map(
            ({ _id, name, color, emoji, sharedWith }, index) => {
              const isSelected = selectedOrganiseList?._id === _id;
              return (
                <SwiperSlide key={_id}>
                  <div
                    style={{
                      backgroundColor: isSelected ? color : "#3B3B3B21",
                    }}
                    className={`flex-shrink-0 text-[20px] w-fit rounded-[12px] h-[72px] md:h-[98px] pl-[17px]  pr-[21px] cursor-pointer font-medium flex items-center space-x-[7px]`}
                    onClick={() =>
                      handleSelectOrganiseList({
                        _id,
                        name,
                        color,
                        emoji,
                      })
                    }
                  >
                    <div
                      style={{
                        background: isSelected
                          ? "rgba(255, 255, 255, 0.27)"
                          : "#737373",
                        zIndex: 1,
                      }}
                      className={`w-[48px] sm:w-[60px] h-[48px] sm:h-[60px] grid place-items-center rounded-full text-2xl sm:text-3xl`}
                    >
                      {emoji}
                    </div>
                    <div className="">
                      <p
                        ref={(el) => (organiseTextRefs.current[index] = el)}
                        style={{ color: isSelected ? "#FFFFFF" : "#000000" }}
                        className={`font-medium w-fit leading-[14px] sm:leading-[24.2px] text-[12px] sm:text-[16px]  md:text-[20px]`}
                      >
                        {name}
                      </p>

                      <div className="flex items-center mt-[2px] justify-start">
                        {sharedWith?.length > 0 &&
                          sharedWith?.map(({ _id, avatar, username }, idx) => (
                            <Avatar
                              key={_id}
                              avatar={avatar}
                              username={username}
                              index={idx}
                              totalAvatars={sharedWith?.length}
                              avatarWidth={29}
                              parentWidth={organiseTextWidths[index]}
                              onAvatarClick={() => null}
                              isList={true}
                            />
                          ))}
                        {/* Avatar tooltip  */}
                        <Tooltip
                          id="avatar_tooltip"
                          place="top"
                          className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-sm"
                        />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            }
          )}
        </Swiper>
        {/* </div> */}
      </div>
    </div>
  );
};

export default OrganiseList;
